$(() => {
  const sameHeight = (element) => {
    const ele = $(element),
      heights = [];
    ele.each((index, element) => {
      const $this = $(element),
        height = $this.css("height", "auto").height();
      heights.push(height);
    });
    const maxHeight = Math.max.apply(null, heights);
    ele.each(() => {
      ele.height(maxHeight);
    });
  };

  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const addEqualHeight = debounce(() => {
    const winWidth = document.documentElement.clientWidth;

    const sectionBlurbs = $(".bs-section--common-content-with-blurbs");
    if (sectionBlurbs.hasClass('bs-section--use-equal-height')) {
      sectionBlurbs.each((index, element) => {
        const $this = $(element),
          childDiv = $this.find(".bs-blurb");
        if (winWidth > 767) {
          $.each(childDiv, (index, element) => {
            sameHeight(childDiv);
          });
        } else {
          childDiv.removeAttr("style");
        }
      });
    }

    const sectionNewsRoomPosts = $(".bs-section--newsroom-latest-news");
    sectionNewsRoomPosts.each((index, element) => {
      const $this = $(element),
        childDiv = $this.find(".bs-post");
      $.each(childDiv, (index, element) => {
        if (winWidth > 767) {
          childDiv.find(".bs-post__title").removeAttr("style");
        } else {
          $.each(childDiv, (index, element) => {
            sameHeight(childDiv.find(".bs-post__title"));
          });
        }
      });
    });
    const sectionNewsRoomPressPosts = $(".bs-section--newsroom-in-the-press");
    sectionNewsRoomPressPosts.each((index, element) => {
      const $this = $(element),
        childDiv = $this.find(".bs-posts__column");
      $.each(childDiv, (index, element) => {
        if (winWidth > 767) {
          $.each(childDiv, (index, element) => {
            sameHeight(childDiv);
          });
        } else {
          childDiv.removeAttr("style");
        }
      });
    });



    const sectionEventsPosts = $(".bs-section--home-upcoming-events");
    sectionEventsPosts.each((index, element) => {
      const $this = $(element),
        childDiv = $this.find(".bs-post");
      $.each(childDiv, (index, element) => {
        sameHeight(childDiv.find(".bs-post__title"));
      });
    });

    const sectionTabSlider = $(".bs-section--common-tab-slider-switch-content-title .bs-tab-slider .bs-slider-content");
    sectionTabSlider.each((index, element) => {
      const $this = $(element),
        childDiv = $this.find(".title-contents");
      $.each(childDiv, (index, element) => {
        sameHeight(childDiv.find("h4"));
      });
    });

    const whoWeServeTabSlider = $(".bs-section--who-we-serve-we-keep-tab-slider .bs-tab-slider .bs-slider-content");
    whoWeServeTabSlider.each((index, element) => {
      const $this = $(element),
        childDiv = $this.find(".slick-track");
      $.each(childDiv, (index, element) => {
        sameHeight(childDiv.find(".slick-slide"));
      });
    });

  }, 10);

  addEqualHeight();

  $(window).on("load resize", () => {
    addEqualHeight();
  });
  $(document).on('facetwp-loaded', () => {
    addEqualHeight();
  });

});
